module.exports = __webpack_public_path__ + "static/CritComf-192931f55cc869a746ef092eebf521eb.jpg";